<template>
  <div id="view">
    <div class="image-section" id="img-1">
      <imageContainer class="image"
                      :imageName="'SZY_9803'"
                      :width="'100%'"
                      :height="'100vh'"></imageContainer>
      <h1 class="title">Rólunk<br>írták</h1>
      <div @click="scrollToSection('#news')" class="arrow white">
        <arrow-svg></arrow-svg>
      </div>
    </div>
    <div id="news">
      <div class="decoration"></div>
      <div class="content" v-if="news">
        <div class="people">
          <div v-for="item in news" class="news-item">
            <div class="img-wrapper">
              <img v-if="item.image === '/media/'" src="../assets/placeholder.png" />
              <img v-else :src="newsImg(item.image)"/>
            </div>
            <div class="text">
              <a :href="item.url" target="_blank"><h3>{{item.name}}</h3></a>
              <p v-if="item.description">{{item.description}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import imageContainer from './../components/imageContainer.vue'
  import arrowSvg from './../components/arrow.vue'

  export default {
    name: 'NewsODPage',
    components: {
      imageContainer,
      arrowSvg
    },
    computed: {
      news () {
        return this.$store.state.about.news
      },
      newsImg () {
        return (imgPath) => {
          return `${this.$store.state.config.baseURL}${imgPath}`
        }
      }
    },
    created() {
      this.$store.dispatch('theme/getTheme', '2020');
    },
    mounted () {
      this.$store.dispatch('about/getNews')
    }
  }
</script>

<style scoped>
  #view {
    position: relative;
  }

  .image-section {
    position: relative;
    width: 100%;
    font-size: 0;
  }

  .image {
    opacity: 0.8;
  }

  .title {
    position: absolute;
    left: 50%;
    top: 20vh;
    margin: 0 0 10px;
    font-size: 120px;
    color: var(--colorA);
    text-transform: uppercase;
    text-shadow: 2px 2px white;
    transform: translateX(-50%);
  }

  .arrow {
    position: absolute;
    bottom: 7vh;
    left: calc(50% - 15px);
    width: 30px;
    height: 30px;
    padding: 5px;
    font-size: 36px;
    color: var(--colorA);
    cursor: pointer;
    z-index: 2;
    border: 2px solid var(--colorA);
    box-sizing: border-box;
  }

  #news {
    position: relative;
    min-height: 100vh;
    padding: 60px 40px;
    border: 10px solid var(--colorA);
    box-sizing: border-box;
  }

  #news h2 {
    top: 0;
    left: 0;
    margin-top: 0;
    margin-bottom: 30px;
    color: var(--colorB);
    align-items: center;
    text-transform: uppercase;
  }

  .content {
    width: 66%;
    max-width: 960px;
    text-align: left;
  }

  .decoration {
    position: absolute;
    width: calc(100vw / 7);
    height: 70vh;
    top: 30vh;
    right: 0;
    background-color: var(--colorA);
    opacity: 0.76;
    z-index: -1;
  }

  .news-item {
    display: flex;
    padding: 40px 0;
    border-bottom: 2px solid #acacac;
  }

  .news-item:last-of-type {
    border-bottom: 0;
  }

  .news-item .img-wrapper {
    width: 200px;
    height: 200px;
    flex-shrink: 0;
    margin-right: 40px;
  }

  .news-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .news-item h3 {
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    margin: 0 0 20px;
  }

  @media (max-width: 768px) {
    .title {
      font-size: 15vh;
    }

    .content {
      width: 80%;
    }

    .news-item .img-wrapper {
      width: 200px;
      height: 200px;
    }
  }

  @media (max-width: 600px) {
    .title {
      top: 45vh;
      font-size: 9vh;
    }

    #news {
      padding: 60px 20px;
      height: auto;
    }

    #news h2 {
      padding-bottom: 10px;
      padding-left: 30px;
      font-size: 21px;
    }

    .content {
      width: 100%;
      padding-top: 20px;
    }

    .news-item {
      flex-direction: column;
      align-items: center;
    }

    .news-item .img-wrapper {
      margin-right: 0;
      margin-bottom: 30px;
    }

    .decoration {
      display: none;
    }
  }

</style>
